import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  IconButton, 
  Box, 
  Avatar, 
  Button, 
  Chip,
  useTheme
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const Navbar = () => {
  const theme = useTheme();
  
  return (
    <AppBar 
      position="fixed" 
      color="default" 
      elevation={0}
      sx={{ 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'white',
        borderBottom: '1px solid rgba(229, 231, 235, 0.8)',
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            sx={{ marginRight: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <img 
            src="/logo192.jpg" 
            alt="Vahan Logo" 
            style={{ 
              height: '32px', 
              marginRight: '12px' 
            }} 
          />
          <Typography variant="h5" noWrap component="div" fontWeight={600} color="text.primary">
            Vahan Analytics
          </Typography>
          
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          
          
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 